import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

//import './styles/Fieldset.scss'
import styles from './Fieldset.module.scss'

export default function Fieldset({ children, className, title }: props) {
  return (
    <div className={classNames('Fieldset', styles.this, 'uk-form-stacked', className)}>
      {title &&
        <legend className="uk-legend uk-margin">
          {/*<legend className="uk-form-label">*/}
          {title}
        </legend>
      }
      {children}
    </div>
  )
}

Fieldset.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Fieldset/Fieldset.js